import IconSvg from 'core/_legacy/icons/IconSvg'

const AmericanExpressLogo = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="#555"
  >
    <g id="surface1">
      <path
        d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z"
        fill="#1976d2"
      />
      <path
        d="M 22.253906 20 L 20.140625 24.683594 L 18.039063 20 L 15.34375 20 L 15.34375 26.726563 L 12.339844 20 L 10.066406 20 L 7 26.980469 L 8.816406 26.980469 L 9.484375 25.421875 L 12.917969 25.421875 L 13.601563 26.980469 L 17.066406 26.980469 L 17.066406 21.796875 L 19.363281 26.980469 L 20.925781 26.980469 L 23.277344 21.886719 L 23.277344 26.980469 L 25 26.980469 L 25 20 Z M 10.136719 23.914063 L 11.160156 21.476563 L 12.226563 23.914063 Z"
        fill="#fff"
      />
      <path
        d="M 37.882813 23.414063 L 41 20.019531 L 38.78125 20.019531 L 36.789063 22.183594 L 34.859375 20 L 28 20 L 28 26.980469 L 34.636719 26.980469 L 36.726563 24.671875 L 38.765625 27 L 40.976563 27 Z M 33.726563 25.515625 L 29.71875 25.515625 L 29.71875 24.136719 L 33.554688 24.136719 L 33.554688 22.8125 L 29.71875 22.8125 L 29.71875 21.503906 L 33.949219 21.515625 L 35.644531 23.414063 Z"
        fill="#fff"
      />
    </g>
  </IconSvg>
)

export default AmericanExpressLogo
